export default "__VITE_ASSET__CiwWxvgm__"